<template>
  <div>
    <template v-for="(item,index) in artilcleList">
      <div class="article-list " @click="goToDetail(item)" :key="index">
          <div class="left related-height">
            <img :src="setImgFn(item.sourceUrl)" alt width="100%" height="100%" />
          </div>
          <div class="right px-1">
            <div class="title">{{item.postTitle}}</div>
            <div class="date">{{item.postDate}}</div>
            <div class="txt">{{item.postExcerpt}}</div>
          </div>
      </div>
    </template>
    
  </div>
</template>

<script>
export default {
  name: "ArticleList",
  props: ["artilcleList"],
  data() {
    return {};
  },

  mounted() {
    // this.handelWidth();
  },
  methods: {
    // handelWidth() {
    //   // console.log("newList");
    //   var container = document.getElementsByClassName("related-height");
    //   console.log(container);
    //   return;
    //   this.playerHeight = container[0].clientWidth / (16 / 9) + "px";
    //   for (var i = 0; i < container.length; i++) {
    //     container[i].style.height = this.playerHeight;
    //   }
    // },
    goToDetail(item) {
      this.$router.push({
        path: "/detail",
        query: {
          postId: item.postId,
        },
      });
    },
  },
  computed: {
    setImgFn() {
      return function(url) {
        if (url) {
          if (url.substring(url.length - 4) == ".gif") {
            // console.log(url)
            let index = url.lastIndexOf(".");
            let tempUrl = url.slice(0, index) + url.slice(index);
            return tempUrl;
          } else {
            let index = url.lastIndexOf(".");
            let tempUrl = url.slice(0, index) +
              "_related" +
              url.slice(index);
            return tempUrl;
          }
        }
      };
    },
  },
  // watch: {
  //   '$route' (to, from) {
  //     this.$router.go(0);
  //   }
  // },
};
</script>

<style lang="less" scoped>
@media screen and (max-width: 768px) {
  .article-list {
    margin-bottom: 10px;
    cursor: pointer;
    width: 100%;
    height: 2.5rem;
    float: left;
    font-size: 16px;
    padding: 0 0.5rem;
    .left {
      height: 2.35rem;
      width: 4rem;
      float: left;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .right {
      height: 2.5rem;
      color: #101010;
      width: calc(100% - 4rem);
      float: left;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      line-clamp: 4;
      -webkit-box-orient: vertical;
      font-weight: 700;
      .date {
        // font-size: 0.12rem;
        display: none;
      }
      .txt {
        font-size: 16px;
        line-height: 0.4rem;
        // margin-top: 0.25rem;
        font-weight: 400;
        display: none;
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .article-list {
    margin-bottom: 10px;
    height: 100% !important;
    .left {
      width: 3rem;
      float: left;
      height: 1.69rem;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .right {
      float: left;
      width: calc(100% - 3rem);
      .title {
        overflow: hidden; /*超出部分隐藏*/
        text-overflow: ellipsis; /* 超出部分显示省略号 */
        white-space: nowrap; /*规定段落中的文本不进行换行 */
      }
    }
    cursor: pointer;
    width: 100%;
    // height: 3rem;
    float: left;
    font-size: 0.28rem;
    .date {
      font-size: 0.12rem;
      line-height: 0.5rem !important;
    }
    .txt {
      height: 50px;
      font-size: 0.16rem;
      // line-height: 0.4rem;
      // margin-top: 0.25rem;
      font-weight: 400;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-clamp: 2;
    }
  }
}
.article-list:hover .title {
  color: #30a2e2;
}
</style>